$(document).ready(function() {

  $(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
      $('.pageheader').addClass('Sticky_Header');
    } else {
      $('.pageheader').removeClass('Sticky_Header');
    }
  });

  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('#crt').html(data);
      $('#crt').removeClass('loading');
    });
  }
  function refreshCart(cart) {
    console.log(cart.item_count);
    $('.cart-link__count').text(cart.item_count);
  }

  $('body').on('click','.product-form__cart-submit',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      addToCartSuccess();
      btn.text('add to cart');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
      $('body').addClass('cartOpen');
    });

  });

  $('body').on('click','.closecart', function(e){
    e.preventDefault();
    $('body').removeClass('cartOpen');
  });

  $('.cart-link').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('cartOpen');
    }, 50);
  });

  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");

    Shopify.changeItem(id,0, function(c){
      $('.itemCount').text(c.item_count);
      if(!c.item_count) {
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
        $.getJSON("/cart.js", function(cart) {
          refreshCart(cart);
        });
      } else {
        addToCartSuccess();
      }
    });
    $.getJSON("/cart.js", function(cart) {
      refreshCart(cart);
    });
  });

  $('.giftreggie-landing-overview a .giftreggie-landing-row h4').text().replace('>', '');
  //   someVariable = someVariable.replace('>', '');
  //   someVariable.text( someVariable );
  //   console.log($('.giftreggie-landing-overview a .giftreggie-landing-row h4').text());
  $('.giftreggie-landing-overview a .giftreggie-landing-row').each(function(){
    var $content = $(this).children('h4');
    var $Text = $content.text();
    $Text.replace('>','');
  })


  jQuery(".same-height").each(function () {
    function e() {
      jQuery(".same-height").css("height", "auto");
      var e = -1;
      jQuery(".same-height").each(function () {
        var t = jQuery(this).outerHeight();
        e = t > e ? t : e
      }), jQuery(".same-height").css("height", e)
    }
    jQuery(this), jQuery(window).on("resize orientationchange", e)
  })

  jQuery(window).on('load resize orientationchange',function(){
    var $window_width = window.innerWidth;
    //     console.log(window.innerWidth);
    if ($window_width < 1024) {
      if(jQuery(".Custom_Testimonial_Inr").hasClass('slick-initialized')){
        jQuery(".Custom_Testimonial_Inr").slick("resize");
      }
      else{
        jQuery('.Custom_Testimonial_Inr').slick({ 
          dots:true, 
          arrows: false, 
          autoplay: true, 
          autoplaySpeed: 2000,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }

          ] 
        })
      }
    }
    else{
      if(jQuery(".Custom_Testimonial_Inr").hasClass('slick-initialized')){
        jQuery(".Custom_Testimonial_Inr").slick('unslick');
      }
    }
  });


  jQuery(window).on('load resize',function(){
    var $window_width = window.innerWidth;
    if ($window_width < 768) {
      if(jQuery(".product_recommend_slider").hasClass('slick-initialized')){
        jQuery(".product_recommend_slider").slick("resize");
      }
      else{
        jQuery('.product_recommend_slider').slick({ 
          dots:true, 
          arrows: false, 
          autoplay: true, 
          autoplaySpeed: 2000,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }

          ] 
        })
      }
    }
    else{
      if(jQuery(".product_recommend_slider").hasClass('slick-initialized')){
        jQuery(".product_recommend_slider").slick('unslick');
      }
    }
  });


  $('.lightly-spaced-row-above .scroll-down').click(function(){
    $('html, body').animate({
      scrollTop: $("#custom-contact-form-section").offset().top - 150
    }, 10);

  });



});

jQuery( document ).ready(function(){
  jQuery(' .open_form ').click(function(){
    jQuery(' .registerform ').show();
    jQuery(' .overlay ').show();
    jQuery(' body ').addClass('overflow-hidden');
  });


  jQuery(' .close_icon ').click(function(){
    jQuery(' .registerform ').hide();
    jQuery(' .overlay ').hide();
    jQuery(' body ').removeClass('overflow-hidden');
  });

  $(".register_form_main").find('.info_form').find(".form-success").parent('.info_form').parent('.register_form_main').parent('.register_form_inner').parent('.registerform').addClass("remove_height");



});


$(document).ready(function(){
  $('body').find(".register_successed").css("display","none");
  setTimeout(function() { 
    if ($('.registerform').find('.register_form').hasClass("register_successed")) {
      jQuery(' .registerform ').show();
      jQuery(' .overlay ').show();
      jQuery(' body ').addClass('overflow-hidden');
    }
  },2000);
});

$(document).on('click','.submit_form',function(){
  jQuery(' .registerform ').show();
  jQuery(' .overlay ').show();
  jQuery(' body ').addClass('overflow-hidden');
});

$(document).ready(function() {
  if ( $(window).width() >= 768 ) {
    startCarousel();
  } else {
    $('.template-suffix-who-we-are .owl-carousel').addClass('off');
    stopCarousel();
  }
});

$(window).on('load resize',function() {
  if ( $(window).width() >= 768 ) {
    startCarousel();
  } else {
    
    stopCarousel();
  }
});

function startCarousel(){
  $('.template-suffix-who-we-are .product-list .product-block').show();
  $(".template-suffix-who-we-are .owl-carousel").owlCarousel({
    navigation : true, // Show next and prev buttons
    slideSpeed : 500,
    margin:10,
    paginationSpeed : 400,
    autoplay:true,
    items : 3,
    itemsDesktop : false,
    itemsDesktopSmall : false,
    itemsTablet: false,
    itemsMobile : false,
    loop:true,
    nav:true,
    navText: ["<i class='fa fa-angle-left' aria-hidden='true'></i>","<i class='fa fa-angle-right' aria-hidden='true'></i>"],
    responsive:{
      1025:{
        items:4,
        center:true
      }
    }
  });
}
function stopCarousel() {

  var owl = $('.template-suffix-who-we-are .owl-carousel');
  owl.trigger('destroy.owl.carousel');
  owl.addClass('off');
  $('.template-suffix-who-we-are .product-list .product-block').slice(4).hide();
}


// equal height muti column section content

$.fn.equalHeights = function(){
  var max_height = 0;
  $(this).each(function(){
    max_height = Math.max($(this).height(), max_height);
  });
  $(this).each(function(){
    $(this).height(max_height);
  });
};

$(document).ready(function(){
  $('.multi-column-section .text-column__text').equalHeights();
});

function Copy() {
  var dummy = document.createElement('input'),
      text = window.location.href;
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  $('.tooltiptext').removeClass('hide');
  document.body.removeChild(dummy);
  setTimeout(function() { 
    $('.tooltiptext').addClass('hide');
  },3000);
}

$(document).on("click", function(e) {
  if ($(e.target).is(".navigation .navigation__tier-1>.navigation__item") === false) {
    $('.navigation .navigation__tier-1>.navigation__item').removeClass('navigation__item--show-children');
  }
  if ($(e.target).is(".logo-area__right") === true) {
    $('a.swym-wishlist , .show-search-link, .header-account-link, .cart-link').removeClass('navigation__item--show-children');
  }

  $('.show-search-link').on('click', function(){
    $('.main-search__input-container input[type=text]').trigger('click');
  });


});


function showExitIntentPop() {
  setTimeout(() => {
    jQuery(document).on("mouseout", evt => {
    if($.cookie('popup_load') === null || $.cookie('popup_load') === ""){ 
      if(evt.toElement === null && evt.relatedTarget === null) {
        jQuery(evt.currentTarget).off("mouseout");
        jQuery('.cc-popup').addClass('cc-popup--visible');
        jQuery('.cc-popup').show();
      }
       }
    });
  }, 2000);
}

jQuery(document).ready(function(){
  if (jQuery('.cc-popup').length > 0) {
    if($(window).width() > 768){
      showExitIntentPop();  
    }
    else{
      if($.cookie('popup_load') === null || $.cookie('popup_load') === ""){ 
                  
          jQuery('.cc-popup').addClass('cc-popup--visible');
          jQuery('.cc-popup').show();
      }
    }
    
    // var date = new Date();
    // date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
    // $.cookie("popup_load", "true", { expires: date });
	};
  
  // close modal
  jQuery(".cc-popup-close").click(function(){
    jQuery('.cc-popup').removeClass('cc-popup--visible');
    jQuery('.cc-popup').hide();
    var date = new Date();
    date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
    $.cookie("popup_load", "true", { expires: date });
  });

  jQuery(window).on('load', function(){
    if (window.location.href.indexOf("?customer_posted=true#footer_newsletter_signup") > -1) {
      console.log('have');
      $(document).scrollTop($(document).height());
    }else{
      console.log('does not have');  
    }
  });
  
});


$(document).ready(function(){
  const currentVariantSelected = $('.swatch-style-listed .detail .product-form .option-selector--swatch .opt-btn:checked').val()
  $(`.product-label .product-label-container .variant-label[data-variant="${currentVariantSelected}"]`).show()

  $('.swatch-style-listed .detail .product-form .option-selector--swatch .opt-label[data-swatch]').click(function(){
    $('.product-label .product-label-container .variant-label').hide();
    const currentVariantSelected = $(this).parents('.option-wrap').find('input.opt-btn').val()
    $(`.product-label .product-label-container .variant-label[data-variant="${currentVariantSelected}"]`).show()
  })
});


